import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import getPersonName from "../../common/Name";
import getPhone from "../../common/Phone";

export const getPersonAddressDetails = (props, phoneInfos, addIndex) => {
  const rows = [];
  let recCount = 0;
  _.forEach(phoneInfos, (phoneInfo, phoneInfoIndex) => {
    const phones = _.get(phoneInfo, "phones");
    const phoneRows = [];
    _.forEach(phones, (phone, phoneIndex) => {
      const listingName = _.get(phone, "phone[0].listingName[0]._", "");
      const tokens = listingName.split(" ");
      const phone1 = _.get(phone, "phone[0].phone10[0]._", "");
      phoneRows.push(
        <Table.Row
          key={`phone_row_${addIndex}_${phoneInfoIndex}_${phoneIndex}`}
          className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell>Contact:</Table.Cell>
          <Table.Cell>
            {getPersonName(
              tokens && tokens.length > 1 ? tokens[1] : "",
              "",
              tokens && tokens.length > 0 ? tokens[0] : "",
              props
            )}
          </Table.Cell>
          <Table.Cell>
            Phone:
            {getPhone(phone1, props)}
          </Table.Cell>
        </Table.Row>
      );
    });

    const nameInfos = _.get(phoneInfo, "residents[0].identity");
    const nameRows = [];
    _.forEach(nameInfos, (names, nameIndex) => {
      const age = _.get(names, "age[0]._", "");
      const dod = _.get(names, "DOD[0].year[0]._", "");
      nameRows.push(
        <Table.Row
          key={`row_contact_${addIndex}_${phoneInfoIndex}_${nameIndex}`}
          className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell />
          <Table.Cell colSpan={2}>
            <span className="text-bold"> Name: </span>{" "}
            {getPersonName(
              _.get(names, "name[0].first[0]._", ""),
              _.get(names, "name[0].middle[0]._", ""),
              _.get(names, "name[0].last[0]._", ""),
              props
            )}
            {age !== "" ? ` Age: ${age}` : null}
            {dod !== "" ? ` DOD: ${dod}` : null}
          </Table.Cell>
        </Table.Row>
      );
    });
    if (nameRows.length > 0) {
      rows.push(
        <Table.Row
          key={`row_phoneinfo_${addIndex}_${phoneInfoIndex}`}
          className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
        >
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>
            <Address addressNode={phoneInfo.address[0]} {...props} />
          </Table.Cell>
          <Table.Cell>
            Dates of occupancy:{" "}
            {_.get(phoneInfo, "dateFirstSeen[0].year[0]._", "")}-
            {_.get(phoneInfo, "dateLastSeen[0].year[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(phoneRows);
      rows.push(nameRows);
      recCount += 1;
    }
  });
  props.updateItemCountBySection(props.sectionName, recCount);
  return rows;
};

export default getPersonAddressDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PersonAddressDetails.js